<div class="filter-tag">
  <div class="lum-label">{{ label }}</div>
  <lum-tag-autocomplete-chip
    [inlineChips]="inlineChips"
    [value]="value"
    (optionSelectedChangeEvent)="onSelectedChangeEvent($event)"
  >
  </lum-tag-autocomplete-chip>
</div>
